import React from "react";

import { PrimaryButton } from "@graffer-inc/console-design-kit";

type Props = {
  onClickCreate: () => void;
};

export const ServiceAccountsListController: React.FC<Props> = ({
  onClickCreate,
}) => {
  return (
    <nav className="level">
      <div className="level-left">{/* TODO: Put search box */}</div>
      <div className="level-right">
        <p className="level-item">
          <PrimaryButton text={"新規登録"} onClick={onClickCreate} />
        </p>
      </div>
    </nav>
  );
};
